import React from 'react';

interface ISeparator {
    margin?: string;
    color?: string;
}

const Separator = (props: ISeparator) => {
    const { margin, color } = props;

    return (
        <div className={ `w-full ${ margin ? margin : '' }` } style={{
            backgroundColor: color ? color : '#eee',
            height: '1px',
        }} />
    )
};

export default Separator;